import React from 'react'
import { useLocale } from '../contexts/LocaleContext'
import { Globe } from 'lucide-react'

const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLocale()

  const languages = [
    { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ]

  return (
    <div className="relative inline-block text-left">
      <div className="flex items-center space-x-2">
        <Globe className="h-4 w-4 text-gray-500" />
        <select
          value={locale}
          onChange={(e) => setLocale(e.target.value as 'en' | 'nl')}
          className="text-sm border border-gray-300 rounded-md px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.flag} {lang.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default LanguageSwitcher


